"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TitleActionButton =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(TitleActionButton, _Backbone$View);

  function TitleActionButton(_ref) {
    var _this;

    var _ref$type = _ref.type,
        type = _ref$type === void 0 ? 'link' : _ref$type,
        action = _ref.action,
        style = _ref.style;

    _classCallCheck(this, TitleActionButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TitleActionButton).apply(this, arguments));

    _this.isSelectEvent = function (e) {
      return (e.type === 'click' || e.which === 13 || e.which === 32) && (e.preventDefault() || true);
    };

    _this.type = type;
    _this.hasCustomAction = false;

    if (!!action) {
      _this.action = action;
      _this.hasCustomAction = true;
    }

    _this.style = style;
    _this.$button = $('<button />');

    _this.listenTo(_this.model, 'change:titleState', _this.render);

    _this.render();

    return _this;
  }

  _createClass(TitleActionButton, [{
    key: "render",
    value: function render() {
      this.$button.off();
      this.$el.off();
      var attributes = this.getButtonAttrs();

      if (_(attributes.href).isEmpty()) {
        this.$button = $('<button />', attributes);
      } else {
        this.$button = $('<a />', attributes);
      } // Attach event handlers if either is true
      // - Button is not a link
      // - Custom action has been provided


      if (_(attributes.href).isEmpty() || this.hasCustomAction) {
        this._attachEventHandlers(this.$button);
      }

      this.$el.empty().append(this.$button);
      return this;
    }
  }, {
    key: "waiting",
    value: function waiting() {
      var isWaiting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (isWaiting) {
        this.$button.off('.titleActionButton').addClass('waiting').attr('disabled', isWaiting).append('<div class="spinner"></div>');
      } else {
        this.$button.removeClass('waiting').attr('disabled', isWaiting).find('.spinner').remove();

        this._attachEventHandlers(this.$button);
      }

      return this;
    }
  }, {
    key: "_attachEventHandlers",
    value: function _attachEventHandlers($el) {
      var _this2 = this;

      $el.off('.titleActionButton');
      $el.on('click.titleActionButton', function (e) {
        _this2.isSelectEvent(e) && _this2.action(e);
      });
      $el.on('keydown.titleActionButton', function (e) {
        _this2.isSelectEvent(e) && _this2.action(e);
      });
    }
  }, {
    key: "action",
    value: function action(event) {
      this.isSelectEvent(event) && this._triggerTitleAction();
    }
  }, {
    key: "_triggerTitleAction",
    value: function _triggerTitleAction() {
      this.model.trigger('title:action', {
        action: this.state,
        model: this.model
      });
    }
  }, {
    key: "getButtonAttrs",
    value: function getButtonAttrs() {
      var buttonAttrs = {
        'data-media-id': this.model.id,
        'data-type': this.model.attributes.type.id,
        'data-type-name': this.model.attributes.type.id && window.html(this.model.attributes.type.id) || '',
        html: this.$button.html && this.$button.html() || '',
        tabindex: 0
      };
      var title = this.model.attributes.title;
      var classes = ['TitleActionButton', 'u-allCaps'];

      if (this.isButton) {
        var _classes;

        (_classes = classes).push.apply(_classes, ['button', 'radius', 'is-button', 'secondary']);
      }

      if (this.style === 'fill') {
        classes.push('fill');
      }

      switch (this.state) {
        case 'recommend':
          classes.push('is-recommend');

          if (this.isLink) {
            classes.push('secondary-color');
          }

          buttonAttrs.html = "<span>".concat(window.html('recommend'), "</span>");
          buttonAttrs['aria-label'] = window.html('recommendTitle', {
            title: title
          });
          break;

        case 'recommended':
          if (this.isButton) {
            classes.push('outline gray');
            classes = _(classes).without('secondary');
          }

          classes.push('is-recommended');
          buttonAttrs.html = "<span>".concat(window.html('recommended'), "</span>");
          buttonAttrs.href = window.url(window.routes.accountRecommendations);
          break;

        case 'unavailable':
          classes.push('is-unavailable js-unavailable disabled');
          buttonAttrs.html = "<span>".concat(window.html('availabilityUnavailable'), "</span>");
          break;

        case 'nook':
          classes.push('is-nook js-nook');
          buttonAttrs.html = "<span>".concat(window.html('sendToNook'), "</span>");
          break;

        case 'preview':
          if (this.isLink) {
            classes.push('secondary-color');
          }

          classes.push('is-preview js-preview secondary');
          buttonAttrs.html = "<span>".concat(window.html('demoMode.preview'), "</span>");
          buttonAttrs['aria-label'] = window.html('demoMode.previewTitle', {
            title: title
          });
          break;

        case 'borrow':
          if (this.isLink) {
            classes.push('secondary-color');
          }

          classes.push('is-borrow js-borrow secondary');
          buttonAttrs.html = "<span>".concat(window.html('borrow'), "</span>");
          buttonAttrs['aria-label'] = window.html('borrowTitle', {
            title: title
          });
          break;

        case 'borrowed':
          classes.push('is-borrowed js-borrowed');
          buttonAttrs.html = "<span>".concat(window.html('goToLoans'), "</span>");
          buttonAttrs.href = window.url(window.routes.accountLoans);
          break;

        case 'hold':
          if (this.isLink) {
            classes.push('secondary-color-hover');
          }

          classes.push('is-hold js-hold');
          buttonAttrs.html = "<span>".concat(window.html('placeAHold'), "</span>");
          buttonAttrs['aria-label'] = window.html('placeAHoldOnTitle', {
            title: title
          });
          break;

        case 'onHold':
          if (this.isButton) {
            classes.push('primary');
          }

          classes.push('is-onHold js-onHold');
          buttonAttrs.html = "<span>".concat(window.html('goToHolds'), "</span>");
          buttonAttrs.href = window.url(window.routes.accountHolds);
          break;

        case 'renew':
          classes.push('is-renew renewalButton');
          classes = classes.filter(function (c) {
            return c !== 'u-allCaps';
          });
          buttonAttrs.html = "<span><i class=\"icon icon-renew\" aria-hidden=\"true\"></i>".concat(window.html('renewal.renewTitle', {
            title: ''
          }), "</span>");
          break;

        case 'requestAgain':
          classes.push('is-requestAgain renewalButton');
          classes = classes.filter(function (c) {
            return c !== 'u-allCaps';
          });
          buttonAttrs.html = "<span><i class=\"icon icon-renew\" aria-hidden=\"true\"></i>".concat(window.html('accountLoans.requestAgain'), "</span>");
          break;

        case 'requested':
          classes.push('is-requested renewalButton');
          classes = classes.filter(function (c) {
            return c !== 'u-allCaps';
          });
          buttonAttrs.html = "<span><i class=\"icon icon-renew\" aria-hidden=\"true\"></i>".concat(window.html('accountLoans.requested'), "</span>");
          break;

        case 'renewed':
          classes.push('is-renewed renewalButton');
          classes = classes.filter(function (c) {
            return c !== 'u-allCaps';
          });
          buttonAttrs.html = "<span><i class=\"icon icon-renew\" aria-hidden=\"true\"></i>".concat(window.html('accountLoans.renewed'), "</span>");
          break;

        case 'listenNow':
          classes.push('is-listenNow');
          buttonAttrs.html = "<span>".concat(window.html('listenNow'), "</span>");
          buttonAttrs.href = window.url(window.routes.mediaDownload, {
            format: 'audiobook-overdrive',
            mediaId: this.model.id
          });
          buttonAttrs.target = '_blank';
          break;

        case 'readNow':
          classes.push('is-readNow');
          buttonAttrs.html = "<span>".concat(window.html('readNow'), "</span>");
          buttonAttrs.href = window.url(window.routes.mediaDownload, {
            format: 'ebook-overdrive',
            mediaId: this.model.id
          });
          buttonAttrs.target = '_blank';
          break;

        case 'addToApp':
          if (this.isLink) {
            classes.push('secondary-color-hover');
          }

          classes.push('is-addToApp');
          buttonAttrs.html = "<span>".concat(window.html('addToApp'), "</span>");
          buttonAttrs.href = window.url(window.routes.mediaDownload, {
            format: this.model.get('addToAppFormat'),
            mediaId: this.model.id
          });
          break;

        case 'waiting':
          if (this.isLink) {
            var dotSpinner = $(window.primaryActionLoadingGif);
            dotSpinner.css('width', 'inherit');
            buttonAttrs.html = dotSpinner;
            break;
          }

          classes.push('waiting secondary');
          buttonAttrs.disabled = true;
          buttonAttrs.html = '<span>working</span><div class="spinner"></div>';
          break;
      }

      buttonAttrs["class"] = classes.join(' ');
      return buttonAttrs;
    }
  }, {
    key: "isButton",
    get: function get() {
      return this.type === 'button';
    }
  }, {
    key: "isLink",
    get: function get() {
      return this.type === 'link';
    }
  }, {
    key: "state",
    get: function get() {
      return this.model.get('titleState');
    }
  }]);

  return TitleActionButton;
}(Backbone.View);

exports["default"] = TitleActionButton;